<template>
  <!-- 车主认证无数据第二步 -->
  <div class="vehicle-owner">
    <div v-cloak class="vehicle-owner-content" v-if="!is_driver">
      <div class="form-item flex form-flex">
        <div class="label font28">车主姓名</div>
        <div class="form-input font28" >{{ userData.name }}</div>
      </div>
      <div class="form-item flex form-flex">
        <div class="label font28">车牌号</div>
        <div @click.stop="openKeyBoard" class="form-input font28" :class="userData.vno ? '' : 'no-input'">{{ userData.vno || '请输入车牌号' }}</div>
      </div>
      <div class="form-item flex form-flex">
        <div class="label font28">车辆归属</div>
        <div class="form-input ascription font28">
          <van-radio-group class="flex radio-group-box font28" v-model="userData.vehicleAuthType">
            <van-radio class="flex4"  checked-color="#5572FC"  :name="1">个人车辆</van-radio>
            <van-radio class="flex6" checked-color="#5572FC"  :name="2">企业车辆(含挂靠)</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div class="form-item flex form-flex">
        <div class="label font28">车牌颜色</div>
        <div class="form-input ascription font28">
          <van-radio-group class="flex radio-group-box font28" v-model="userData.vco">
            <van-radio class="flex4" checked-color="#5572FC" :name="1">
              <div class="license-plate yellow-car">黄牌车</div>
            </van-radio>
            <van-radio class="flex6" checked-color="#5572FC" :name="2">
              <div class="license-plate bule-car">蓝牌车</div>
            </van-radio>
          </van-radio-group>
        </div>
      </div>
      <div class="form-item flex form-flex">
        <div class="label font28">我也是驾驶员？</div>
        <div class="form-input ascription font28">
          <van-radio-group class="flex radio-group-box font28" v-model="userData.hasDriver">
            <van-radio class="flex4"  checked-color="#5572FC"  :name="true">是</van-radio>
            <van-radio class="flex6" checked-color="#5572FC"  :name="false">否</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div class="form-item" v-if="userData.vehicleAuthType">
        <div class="label font28">上传行驶证</div>
        <div class="form-input">
          <van-uploader :multiple="false" :max-count="1"   :after-read="afterReadDriving" accept='image/*' class="flex" style="justify-content: center;">
            <div class="driving-license">
              <img class="upload-img" :src="imgTravel" alt="" srcset="">
              <div class="shot-box flex">
                <img src="../../assets/images/attestation/icon-camera.png" alt="" srcset="">
                <div>点击上传行驶证正面</div>
              </div>
            </div>
          </van-uploader>
        </div>
      </div>
      <div class="form-item" v-if="userData.vehicleAuthType === 2">
        <div class="label font28">营业执照（需加盖公章）</div>
        <div class="form-input">
          <van-uploader :multiple="false" :max-count="1"   :after-read="afterReadBusiness" accept='image/*' class="flex" style="justify-content: center;">
            <div class="business-license">
              <img class="license-img" :src="imgBusiness" alt="" srcset="">
              <div class="shot-box flex">
                <img src="../../assets/images/attestation/icon-camera.png" alt="" srcset="">
                <div>点击上传行驶证正面</div>
              </div>
            </div>
          </van-uploader>
        </div>
      </div>
    </div>
    <div v-cloak class="driver-content" v-else>
      <div class="form-item">
        <div class="label font28">真实姓名</div>
        <div class="form-input font28">{{ driverData.name }}</div>
      </div>
      <div class="form-item">
        <div class="label font28">驾驶证</div>
        <div class="form-input font28">
          <van-uploader :multiple="false" :max-count="1"   :after-read="afterReadDrivingLicense" accept='image/*' class="flex" style="justify-content: center;">
            <div class="driving-license">
              <img class="upload-img" :src="imgDriver" alt="" srcset="">
              <div class="shot-box flex">
                <img src="../../assets/images/attestation/icon-camera.png" alt="" srcset="">
                <div>点击上传驾驶证正面</div>
              </div>
            </div>
          </van-uploader>
        </div>
      </div>
    </div>
    <div class="contact-service" v-if="!isAndroidApp">
      如有疑问请<span @click.stop="goContact">联系客服</span>
    </div>
    <truck-keyboard
      v-if="showKeyBoard"
      :searchTitle="'关闭'"
      :vclNo="userData.vno"
      @searchBtn="showKeyBoard=false"
      @deletevclNo="keyBoardDeletevclNo"
      @confirm="getkeyBoard">
    </truck-keyboard>
    <van-button
      class="btn"
      @click="submitBtn"
      :loading="btnLoading"
      type="info"
      loading-text="审核中..." >
      提交审核
    </van-button>
    <success-dialog
      :isGiveTicket="isGiveTicket"
      :isPerson="is_person"
      :code="examineCode"
      :type="is_driver ? 2 : 1"
      :errorMessage= "examineMessage"
      @define="successDigDefinBtn"
      ref="SuccessDialog"
    >
    </success-dialog>
    <tip-dialog
      title="提示"
      message="图片过大，请重新选择"
      ref="TipDialog">
    </tip-dialog>
  </div>
</template>

<script>
import { Toast } from 'vant'
import lrz from 'lrz'
import { wxRaLunch } from '../../utils/WeChatUtil'
import IconCamera from '../../assets/images/attestation/driving-license-example.png'
import IconBusiness from '../../assets/images/attestation/business-license.png'
import IconDriver from '../../assets/images/attestation/drivers-license.png'
import SuccessDialog from '../../components/dialog/Attestation/successDialog'
import TipDialog from '../../components/dialog/TipDialog'
import TruckKeyboard from '../../components/truckKeyboard/index'
import { wxNavigateTo } from '../../utils/WeChatUtil'
import { createVehicleAuth, createDriverAuth, getAuthInfoDraft } from '../../api/attestation'
import { errorData } from '../../utils/attestation'
export default {
  props: {},
  data() {
    return {
      is_driver: false, // 是否是驾驶员
      userData: {
        vehicleAuthType: null, // 1个人车辆 2企业车辆
        vno: '', // 车牌号
        vco: null, // 车牌颜色 1黄 2蓝
        name: '', // 姓名
        phone: '', // 电话
        hasDriver: true,
        vehicleLicenseImg: null, // 行驶证照片file
        businessLicenseImg: null, // 营业执照照片file
      },
      driverData: {
        name: '',
        file: null
      },
      imgTravel: IconCamera, // 要显示的行驶驶证上传图片
      imgBusiness: IconBusiness, // 要显示的上传营业执照图片
      imgDriver: IconDriver, // 要显示的驾驶证照片
      examineCode: null, // 认证结果code
      examineMessage: null, // 认证结果message
      btnLoading: false, // btn加载状态
      showKeyBoard: false, // 显示键盘
      isGiveTicket: true, // 是否赠票
      is_person: false, // 是否是个人认证过来的车主认证
    };
  },
  computed: {},
  components: {
    SuccessDialog,
    TipDialog,
    TruckKeyboard
  },
  async created() {
    document.body.addEventListener('click', this.closeKeyBoard, false)
    await this.getdraftData()
    const { is_driver, is_person } = this.$route.query
    this.is_driver = is_driver ? true : false
    this.is_person = is_person ? true : false
  },
  mounted() {},
  watch: {},
  methods: {
    /**
     *
     * @param fileData 车辆行驶证图片文件
     *
     * 上传车辆行驶证图片文件
    */
    async afterReadDriving(fileData) {
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      const file = await this.compress(fileData)
      const { content } = fileData
      if (file.size > 4242880) {
        this.$refs.TipDialog.showPopup()
        return
      }
      this.imgTravel = content
      this.userData.vehicleLicenseImg =  file
    },
    /**
     *
     * @param fileData 营业执照图片文件
     *
     * 上传营业执照图片文件
    */
    async afterReadBusiness(fileData) {
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      const { content } = fileData
      const file = await this.compress(fileData)
      if (file.size > 4242880) {
        // 图片过大
        this.$refs.TipDialog.showPopup()
        return
      }
      this.imgBusiness = content
      this.userData.businessLicenseImg = file
    },
    /**
     *
     * @param fileData 司机认证驾驶证图片文件
     *
     * 上传司机认证驾驶证图片文件
    */
    async afterReadDrivingLicense(fileData) {
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      const { content } = fileData
      const file = await this.compress(fileData)
      if (file.size > 4242880) {
        this.$refs.TipDialog.showPopup()
        return
      }
      this.imgDriver = content
      this.driverData.file = file
    },
    /**
     *
     *
     *
     * 成功弹框确定事件
    */
    successDigDefinBtn() {
      const { examineCode, isWechart } = this
      if (examineCode === 70402 || examineCode === 10000 || examineCode === 0) {
        if (isWechart) {
          // 微信小程序
          wxRaLunch('/pages/index/index')
        } else {
          // 苹果和安卓客户端
          window.location.href = 'https://www.success.vehicle.owner/'
        }
      } else {
        this.imgTravel = IconCamera
        this.imgBusiness = IconBusiness
        this.userData.vehicleLicenseImg = null
        this.userData.businessLicenseImg = null
      }
    },
    /**
     *
     *
     *
     * 提交审核按钮
    */
    submitBtn() {
      const { vehicleAuthType, vno, vco, businessLicenseImg, vehicleLicenseImg } = this.userData
      if (!navigator.onLine) {
        Toast('网络异常，请检查网络')
        this.btnLoading = false
        return
        // 断网了
      }
      if (this.btnLoading) {
        return
      }
      if (!this.is_driver) {
        if (!vno || vno.length < 6) {
          Toast('请输入正确的车牌号')
          return
        }
        // 车主认证
        if (!vehicleAuthType) {
          Toast('请选择车辆归属')
          return
        }
        if (!vco) {
          Toast('请选择车牌颜色')
          return
        }
        if (!vehicleLicenseImg) {
          Toast('请上传行驶证照片')
          return
        }
        if (vehicleAuthType === 2 && !businessLicenseImg) {
          Toast('请上传企业营业执照')
          return
        }
        this.authenticationGo()
      } else {
        // 驾驶员认证
        if (!this.driverData.file) {
          Toast('请上传驾驶证照片')
          return
        }
        this.authDriverGO()
      }
    },
    /**
     *
     *  @param fileData 图片文件
     * 压缩图片
    */
    async compress(fileData) {
      const { file } = fileData
      const fileresult = await lrz(file, {
        width: 600,
        height: 800,
        quality: .9
      })
      return fileresult.file
    },
    /**
     *
     *
     * 车主认证go
    */
    async authenticationGo() {
      const {
        vehicleAuthType,
        vno,
        vco,
        name,
        phone,
        hasDriver,
        vehicleLicenseImg,
        businessLicenseImg,
      } = this.userData
      let param = new FormData()
      param.append('vehicleAuthType', vehicleAuthType)
      param.append('vno', vno)
      param.append('vco', vco)
      param.append('name', name)
      param.append('phone', phone)
      param.append('hasDriver', hasDriver)
      param.append('vehicleLicenseImg', vehicleLicenseImg)
      if (businessLicenseImg) {
        param.append('businessLicenseImg', businessLicenseImg)
      }
      this.btnLoading = true
      const response = await createVehicleAuth(param)
      this.btnLoading = false
      if (response) {
        const { success, code, msg, data } = response
        this.examineMessage = msg
        if (success) {
          // 认证成功
          if (!data.hasAddTicket && !this.is_person) {
            this.isGiveTicket = false
          }
          this.examineCode = 0
          this.$refs.SuccessDialog.showPopup()
        } else {
          this.examineCode = code
          if (errorData.indexOf(code) >= 0) {
            this.$refs.SuccessDialog.showPopup()
          } else {
            Toast(msg)
          }
        }
      }
      console.log(response)
    },
    /**
     *
     *
     * 驾驶员认证
    */
    async authDriverGO() {
      let param = new FormData()
      const { name, file } = this.driverData
      param.append('name', name)
      param.append('file', file)
      this.btnLoading = true
      const response = await createDriverAuth(param)
      this.btnLoading = false
      if (response) {
        const { success, code, msg } = response
        this.examineMessage = msg
        this.examineCode = code
        if (success) {
          // 认证成功
          this.examineCode = 0
          this.$refs.SuccessDialog.showPopup()
        } else if (errorData.indexOf(code) >= 0) {
          this.$refs.SuccessDialog.showPopup()
        } else {
          Toast(msg)
        }
      }
    },
    /**
     *
     *
     * 获取认证时的草稿信息
    */
    async getdraftData() {
      const response =  await getAuthInfoDraft()
      if (response.success) {
        const { name } = response.data
        this.driverData.name = name
        this.userData.name = name
      }
    },
    /**
     *
     *
     * 去联系客服页面
    */
    goContact() {
      if (this.isWechart) {
        wxNavigateTo('/pages/custom/custom')
      }
    },
    /**
     *
     * @param data 键盘输入的车牌
     *
     * 获取键盘输入的数据
    */
    getkeyBoard(data) {
      const { vno } = this.userData
      this.userData.vno = vno + data
    },
    /**
     *
     *
     * 关闭键盘
    */
    closeKeyBoard () {
      this.showKeyBoard = false
    },
    /**
     *
     *
     * 删除车牌号一位
    */
    keyBoardDeletevclNo() {
      const { vno } = this.userData
      this.userData.vno = vno.substring(0, vno.length-1)
    },
    /**
     *
     *
     * 显示键盘输入车牌号
    */
    openKeyBoard() {
      this.showKeyBoard = !this.showKeyBoard
    },
  }
};
</script>

<style scoped lang="scss">
[v-cloak] {
  display: none
}
.vehicle-owner {
  .font28 {
    font-size: 28px
  }
  .flex4 {
    flex: .4
  }
  .flex6 {
    flex: .6
  }
  .form-item {
    .label {
      padding: 30px 0 30px 20px;
      color: #989898;
      font-weight: 500;
    }
    .form-input {
      background-color: #ffffff;
      padding: 30px 40px;
      .radio-group-box {
        font-weight: 500;
        justify-content: space-between;
      }
      .driving-license {
        text-align: center;
        .upload-img {
          width: 410px;
        }
      }
      .business-license {
        text-align: center;
        .license-img {
          width: 249px
        }
      }
      .shot-box {
        justify-content: center;
        align-items: center;
        font-size: 24px;
        font-weight: 500;
        text-decoration: underline;
        padding-top: 30px;
        color: #5277FF;
        img {
          width: 40px;
          padding-right: 20px;
        }
      }
    }
  }
  .form-flex {
    background-color: #ffffff;
    border: 1px solid #F2F2F2;
    .ascription {
      flex: 1
    }
    .form-input {
      padding-right: 0;
    }
  }
  .contact-service {
    font-size: 24px;
    color: #CCCCCC;
    text-align: center;
    padding-top: 60px;
    span {
      color: #5572FD;
      text-decoration: underline;
    }
  }
  .btn {
    width: 90%;
    background-color: #5572FD;
    color: #ffffff;
    border-radius: 3px;
    font-size: 28px;
    text-align: center;
    line-height: 80px;
    height: 80px;
    margin-top: 30px;
    left: 50%;
    margin-left: -45%;
    margin-bottom: 80px;
  }
  .no-input {
    color: #E5E5E5;
  }
  .license-plate {
    padding: 6px 20px;
    border: 3px solid #282828;
    border-radius: 6px;
    margin-left: 10px;
  }
  .yellow-car {
    background-color: #fec22c;
  }
  .bule-car {
    background-color: #5277FF;
    color: #ffffff;
  }
}
</style>
